import React, { Component, Fragment } from "react";

export default class Navbar extends Component {

    constructor(props) {
        super(props);

        this.state = {
            link: "/producaoep"
        }
    }

    render() {
        let { link } = this.state;
        return (
            <Fragment>
                <nav className="navbar navbar-dark bg-primary sticky-top ">
                    <div className="container-fluid flex-wrap">
                        <a className="navbar-brand" href="/">Relatório da produção de Educação Profissional do SENAI</a>
                        <ul className="navbar-nav flex-row flex-wrap">
                            <li className="nav-item">
                                <a className="nav-link active text-white px-2" aria-current="page" href="/">Início</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link text-white px-2" href={`${link}/relatorio1`}>Realizado</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link text-white px-2" href={`${link}/relatorio4`}>Metas</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link text-white px-2" href={`${link}/relatorio3`}>Meta e Realizado</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link text-white px-2" href={`${link}/relatorio2`}>Relatório Dinâmico</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link text-white px-2" href={`${link}/upload`}>Upload</a>
                            </li>
                        </ul>
                    </div>
                </nav>
            </Fragment>
        )
    }
}